<div class="new-site__modal">
    <h3>Welcome to the new SGC!</h3>
    <p>{{modalCopy}}</p>
    <button class="button" (click)="close()">Got it!</button>
</div>